import { type FC } from 'react';

// MUI
import TableCell from '@mui/material/TableCell';

// screen
import { formatUTC } from 'modules/map/components/pdf-print-form/utils';
import SizedText from 'modules/map/components/pdf-print-form/styled-components/SizedText';

interface PdfWeekdayProps {
  rowSpan?: number;
  datetime?: string;
  beBold?: boolean;
}

const PdfWeekday: FC<PdfWeekdayProps> = (props) => {
  const { rowSpan = 1, datetime = '', beBold } = props;

  return (
    <TableCell rowSpan={rowSpan}>
      <SizedText sx={{ fontWeight: beBold ? 600 : 'normal' }}>
        <span className="capitalize">{formatUTC(datetime, 'dddd')}</span>
        <br />
        {datetime && formatUTC(datetime, 'L')}
      </SizedText>
    </TableCell>
  );
};

export default PdfWeekday;
